import { gql, TypedDocumentNode } from "@apollo/client";

import {
  QueryStacksWithAccessToSpaceArgs,
  QueryStacksWithAccessToSpaceSuggestionsArgs,
  Role,
  SearchSuggestionsOutput,
  Space,
  SpaceAccessStack,
  StackSpaceAccessRoleGrant,
  StacksWithAccessToSpaceOutput,
} from "types/generated";

type SpaceDetailsStackGrantNode = Pick<StackSpaceAccessRoleGrant, "source"> & {
  role: Pick<Role, "id" | "name" | "isSystem">;
  space: Pick<Space, "id" | "name">;
};

type SpaceDetailsStackNode = {
  stack: Pick<SpaceAccessStack, "id" | "name" | "state" | "labels">;
  roles: Array<SpaceDetailsStackGrantNode>;
};

type StacksWithAccessToSpaceData = {
  stacksWithAccessToSpace: {
    edges: Array<{ cursor: string; node: SpaceDetailsStackNode }>;
    pageInfo: StacksWithAccessToSpaceOutput["pageInfo"];
  };
};

export const STACKS_WITH_ACCESS_TO_SPACE: TypedDocumentNode<
  StacksWithAccessToSpaceData,
  QueryStacksWithAccessToSpaceArgs
> = gql`
  query StacksWithAccessToSpace($space: ID!, $input: SearchInput!, $mode: StackAccessMode!) {
    stacksWithAccessToSpace(space: $space, input: $input, mode: $mode) {
      edges {
        cursor
        node {
          stack {
            id
            name
            state
            labels
          }
          roles {
            source
            role {
              id
              name
              isSystem
            }
            space {
              id
              name
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;

type StacksWithAccessToSpaceCountData = {
  stacksWithAccessToSpaceSuggestions: {
    filteredCount: SearchSuggestionsOutput["filteredCount"];
  };
};

export const STACKS_WITH_ACCESS_TO_SPACE_COUNT: TypedDocumentNode<
  StacksWithAccessToSpaceCountData,
  QueryStacksWithAccessToSpaceSuggestionsArgs
> = gql`
  query StacksWithAccessToSpaceCount(
    $space: ID!
    $input: SearchSuggestionsInput!
    $mode: StackAccessMode!
  ) {
    stacksWithAccessToSpaceSuggestions(space: $space, input: $input, mode: $mode) {
      filteredCount
    }
  }
`;
